<div class="p-4 space-y-4">
  <form [formGroup]="form">
    <app-lupas 
      formControlName="Codigo" 
      [dataSearhLupa]="dataSearchLupaPasoDestino"
      (itemSeleccionado)="onPasoSeleccionado($event)"
      class="w-full mb-5"
    >
    </app-lupas>
    <textarea
      pInputTextarea
      formControlName="Motivo"
      placeholder="Escriba aquí el motivo..."
      rows="5"
      class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors duration-200"
    >
    </textarea>
    @if (mostrarCheck) {
    <p-checkbox
        formControlName="ArrastrarDoctos"
        [binary]="true"
        inputId="ArrastrarDoctos">
      </p-checkbox>

      <label for="ArrastrarDoctos" class="ml-2">
        Ojo, Si esta activo checkbox arrastra los demás documentos que sean parte del mismo paso.
      </label>
    }
  </form>
</div>

<div class="flex justify-end gap-3 pt-4">
  <p-button
    type="button"
    label="Cancelar"
    icon="icon-cross"
    severity="danger"
    outlined
    (click)="cerrarModal()"
  >
  </p-button>

  <p-button
    type="button"
    label="Aceptar"
    icon="icon-switch"
    severity="success"
    [disabled]="form.invalid"
    outlined
    (click)="confirmar()"
  >
  </p-button>
</div>
